import { createResourceKeys } from "@/lib/resource-context";

// Three caches render tool data: flat lists, catalog entries (requirement
// badges), and per-toolkit drill-down tables. A mutation that changes tool
// data or requirement readiness must invalidate all three — see the
// *MutationInvalidates helpers in app/secrets and app/servers.
export const toolsKeys = createResourceKeys("tools");
export const toolCatalogKeys = createResourceKeys("tool_catalog");
export const toolkitToolsKeys = createResourceKeys("toolkit_tools");
